import { Injectable } from '@angular/core';
import { HttpNewService } from './application/http-new.service';
import { AuthService } from './auth.service';
import { Observable } from 'rxjs';
import { IRnumbList } from '../interfaces/rnumb.interfaces';
import { IServ } from '../interfaces/record.interfaces';

@Injectable({
    providedIn: 'root',
})
export class RnumbService {
    public constructor(
        private httpNew: HttpNewService,
        private auth: AuthService,
    ) {}

    /**
     * Список талонов
     * @param parameters
     */
    public getRnumbList(): Observable<Array<IRnumbList>> {
        let url = '/rnumb/list';
        return this.httpNew.get<Array<IRnumbList>>(url, null);
    }

    /**
     * Услуги на талон талонов
     * @param parameters
     */
    public getRnumbSrv(rnumbId: number): Observable<IServ> {
        let url = '/record/rnumb/serv';
        url = url + `?rnumbId=${rnumbId}`;
        return this.httpNew.get<IServ>(url, null);
    }
}
